import dayjs from 'dayjs';

import type { ConversationListItem } from '@captivateiq/assistant/types';

export type ConversationGroupKey = 'today' | 'yesterday' | 'last_week' | 'last_month' | 'earlier';

export type ConversationGroup = {
  key: ConversationGroupKey;
  conversations: ConversationListItem[];
};

export const CONVERSATION_GROUP_ORDER: ConversationGroupKey[] = [
  'today',
  'yesterday',
  'last_week',
  'last_month',
  'earlier',
];

const bucketFor = (updatedAt: string, now: dayjs.Dayjs): ConversationGroupKey => {
  const diffDays = now.startOf('day').diff(dayjs(updatedAt).startOf('day'), 'day');
  if (diffDays <= 0) return 'today';
  if (diffDays === 1) return 'yesterday';
  if (diffDays < 7) return 'last_week';
  if (diffDays < 30) return 'last_month';
  return 'earlier';
};

/**
 * Buckets conversations into fixed, ordered date sections without re-sorting within a bucket —
 * callers already receive them newest-updated-first from the API.
 */
export const groupConversationsByDate = (
  conversations: ConversationListItem[],
  now: dayjs.Dayjs = dayjs(),
): ConversationGroup[] => {
  const buckets = new Map<ConversationGroupKey, ConversationListItem[]>();

  conversations.forEach((conversation) => {
    const key = bucketFor(conversation.updated_at, now);
    const bucket = buckets.get(key) ?? [];
    bucket.push(conversation);
    buckets.set(key, bucket);
  });

  return CONVERSATION_GROUP_ORDER.filter((key) => buckets.has(key)).map((key) => ({
    key,
    conversations: buckets.get(key) as ConversationListItem[],
  }));
};
